/*////////////////////////////////
PHC / Update product card prices based on cookies availability
////////////////////////////////*/
const targetNode = document.body;
const observerCallback = (mutationsList, observer) => {
    for(let mutation of mutationsList) {
        if(mutation.target.hasAttribute && mutation.target.hasAttribute('data-ignore-observe')) {
            continue;
        }

        const dom_with_subs = document.querySelectorAll('[data-subs-price]');
        const dom_with_onetime = document.querySelectorAll('[data-onetime-price]');

        // Check if phc member cookies are available

        // Treating active user as PHC member
        if(dom_with_subs.length > 0) {
            Array.from(dom_with_subs).forEach(subsDOM => {
                // Get user in session
                const user = subsDOM.getAttribute('data-user-in-session');

                let finalPrice = '';
                if(user === 'staff_member' || user === 'phc_member') {
                    if(user === 'staff_member') {
                        finalPrice = subsDOM.getAttribute('data-staff-subs-price');
                    } else {
                        finalPrice = subsDOM.getAttribute('data-phc-subs-price');
                    }
                } else {
                    if(getPhcCookie()) {
                        finalPrice = subsDOM.getAttribute('data-phc-subs-price');
                    } else {
                        finalPrice = subsDOM.getAttribute('data-guest-subs-price');
                    }
                }

                // formatMoney from theme.js
                subsDOM.setAttribute('updated-price', `${formatMoney(finalPrice)} with Repeat & Save`);
                subsDOM.innerHTML = `${formatMoney(finalPrice)} with Repeat & Save`;
            });
        }

        // Method from custom.js
        if(dom_with_onetime.length > 0) {
            Array.from(dom_with_onetime).forEach(el => {
                // Get user in session
                const user = el.getAttribute('data-user-in-session');
                const updateFlag = el.getAttribute('data-update-onetime');

                if (updateFlag === 'true') {
                    let finalPrice = '';
                    if(user === 'staff_member' || user === 'phc_member') {
                        if(user === 'staff_member') {
                            finalPrice = el.getAttribute('data-staff-discount');
                        }

                        if(user === 'phc_member') {
                            finalPrice = el.getAttribute('data-phc-discount');
                        }
                    } else {
                        if(getPhcCookie()) {
                            finalPrice = el.getAttribute('data-phc-discount');
                        }
                    }

                    if(getPhcCookie() || user === 'staff_member' || user === 'phc_member') {
                        const pricePrefix = el.getAttribute('data-price-prefix');
                        if(pricePrefix) {
                            el.innerHTML = pricePrefix.replace(/\{\{.*?\}\}/, formatMoney(finalPrice));
                        } else {
                            el.innerHTML = formatMoney(finalPrice);
                        }
                    }
                }
            })
        }
    }
}

const observer = new MutationObserver(observerCallback);

const config = { childList: true, subtree: true };
observer.observe(targetNode, config);